import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  total_records?: number | undefined;
  data: ResponseData;
  status: number;
  message: string;
  file_urls?: string;
};
type ResponseData = {
  response_object: any;
  total_records: number;
  start: number;
  length: number;
};

type UpdateOrderParams = {
  body: any;
  id: string | undefined;
};

type Body = {
  start: number;
  length: number;
  search: string;
};

type PaymentBody = {
  body: {
    refund_amount: string;
  };
  id: number;
};

export const orderApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    allOrders: builder.mutation<CommonResponseType, Body>({
      query: (body) => ({
        url: END_POINTS.allOrders,
        method: "POST",
        body,
      }),
    }),
    orderDetailById: builder.query({
      query: (id) => ({
        url: `${END_POINTS.orderDetailById}${id}/`,
        method: "GET",
      }),
    }),
    GetOrderDetailById: builder.query({
      query: (id) => ({
        url: `${END_POINTS.oderByiD}${id}/`,
        method: "GET",
      }),
    }),
    updateOrderStatus: builder.mutation<CommonResponseType, UpdateOrderParams>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.orderStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    refundRequests: builder.mutation<CommonResponseType, Body>({
      query: (body) => ({
        url: END_POINTS.refund,
        method: "POST",
        body,
      }),
    }),

    refundPayment: builder.mutation<CommonResponseType, PaymentBody>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.refundPayment}${id}/`,
        method: "POST",
        body,
      }),
    }),

    getOrderCsv: builder.mutation<CommonResponseType & { data: any }, {}>({
      query: (body) => ({
        url: END_POINTS.orderCsv,
        method: "POST",
        body,
      }),
    }),

    getOrderCount: builder.mutation<CommonResponseType & { data: any }, {}>({
      query: (body) => ({
        url: END_POINTS.orderCount,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useAllOrdersMutation,
  useLazyOrderDetailByIdQuery,
  useUpdateOrderStatusMutation,
  useRefundRequestsMutation,
  useGetOrderCsvMutation,
  useLazyGetOrderDetailByIdQuery,
  useGetOrderCountMutation,
  useRefundPaymentMutation,
} = orderApi;
